<template>
  <div class="cont-componente-menu">
    <v-btn color="primary" icon dense small @click="bMenuIn = !bMenuIn">
      <v-icon >mdi-menu</v-icon>
    </v-btn>
    <!-- MENU VERSIÓN WEB -->
    <v-slide-x-transition transition="scroll-y-transition" v-if="!$vuetify.breakpoint.xs">
      <div v-if="bMenuIn" class="cont-menu-principal">
        <ul class="ul-menu" @mouseleave="bMenuIn = false">
          <li v-for="itemMenu in aMenu" :key="itemMenu.idMenuModulo"
            @click="onIr(itemMenu.Ruta,itemMenu.acceso)"
            >
            <div class="cont-item-menu">
              <v-icon class="mr-1 icono-item-menu">{{itemMenu.Icono}}</v-icon>
              {{itemMenu.Menu}}	
              <v-icon class="ml-auto icon-chevron" v-show="itemMenu.Hijos.length > 0">mdi-chevron-right</v-icon>
            </div>
            <ul v-if="itemMenu.Hijos.length > 0" class="animated fadeIn">
              <li	v-for="child in itemMenu.Hijos" :key="child.idSubItemMenu" @click="onIr(child.SubTo,child.acceso)">
              <div class="cont-item-menu">
                <v-icon class="mr-1 icono-item-menu">{{child.Icon}}</v-icon>{{child.SubItem}} <v-icon class="ml-auto" v-show="child.Hijos.length > 0">mdi-chevron-right</v-icon>
              </div>
              <ul v-if="child.Hijos.length > 0" class="animated fadeIn">
                <li	v-for="itemMenu2 in child.Hijos" :key="itemMenu2.idSubItemMenu"	@click="onIr(itemMenu2.SubTo,itemMenu2.acceso)">
                  <div class="cont-item-menu">
                    <v-icon class="mr-1 icono-item-menu">{{itemMenu2.Icon}}</v-icon>{{itemMenu2.SubItem}}
                  </div>
                </li>
              </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </v-slide-x-transition>
    <!-- MENU VERSIÓN MOBILE -->
    <v-dialog v-if="$vuetify.breakpoint.xs"
          v-model="bMenuIn"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          scrollable
        >
        <v-card tile>
          <v-toolbar flat dark color="primary" class="dialog-menu" >
            <v-spacer></v-spacer>
            <v-btn icon dark small class="ma-0" @click="bMenuIn = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-1 ma-0">
            <v-list dense class="pa-1 ma-0">
              <v-list-item v-for="itemMenu in aMenu" :key="itemMenu.idMenuModulo" class="ma-0 pa-0">
                <v-list-item-content class="pa-1">
                  <div class="cont-item-menu-xs">
                    <div class="item-menu-xs" @click="onIr(itemMenu.Ruta,itemMenu.acceso)">
                      <v-icon class="icono-item-menu-xs">{{itemMenu.Icono}}</v-icon>
                      {{itemMenu.Menu}} 
                    </div>
                    <v-btn fab small class="ml-auto" v-show="itemMenu.Hijos.length > 0" @click="onExpandMenu('A','itemMenu'+itemMenu.idMenuModulo+'')">
                      <v-icon>mdi-chevron-down</v-icon> 
                    </v-btn>
                  </div>
  
                  <v-expand-transition>
                    <v-list dense class="pa-1 ma-0" v-if="itemMenu.Hijos.length > 0 && itemNumMenu == ('itemMenu'+itemMenu.idMenuModulo+'')">
                      <v-list-item v-for="child in itemMenu.Hijos" :key="child.idSubItemMenu" class="ma-0 pa-0">
                        <v-list-item-content class="pa-1">
                          <div class="cont-item-menu-xs">
                            <div class="item-menu-xs" @click="onIr(child.SubTo,child.acceso)">
                              <v-icon class="icono-item-menu-xs">{{child.Icon}}</v-icon>
                              {{child.SubItem}}
                            </div>
                            <v-btn fab small class="ml-auto" v-if="child.Hijos.length > 0" @click="onExpandMenu('B','child'+child.idSubItemMenu+'')">
                              <v-icon>mdi-chevron-down</v-icon> 
                            </v-btn>
                          </div>
  
                          <v-expand-transition>
                            <v-list class="pa-1 ma-0" dense v-if="child.Hijos.length > 0 && itemNumMenuB == ('child'+child.idSubItemMenu+'')">
                              <v-list-item v-for="itemMenu2 in child.Hijos" :key="itemMenu2.idSubItemMenu" class="ma-0 pa-0">
                                <v-list-item-content class="pa-1">
                                  <div class="cont-item-menu-xs">
                                    <div class="item-menu-xs" @click="onIr(itemMenu2.SubTo,itemMenu2.acceso)">
                                      <v-icon class="icono-item-menu-xs">{{itemMenu2.Icon}}</v-icon>
                                      {{itemMenu2.SubItem}}
                                    </div>
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-expand-transition>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-expand-transition>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
    </v-dialog>
    <modal-mensaje v-model="bModalPermisos" sMensaje="No tiene permisos para ver este menú" :nTipo="2"/>
  </div>
  </template>
  <script>
   import ModalMensaje from '@/components/ModalMensaje.vue'
  export default {
      name:'MenuPrincipal',
      props: {
        aMenu: {
          type: Array,
        },
        nNivel:{
          type: Number,
          Default: 1
        },
      },
      components: {
        ModalMensaje
      },
      data() {
        return {
          nNivelActual: 0,
          nSubNivel: 0,
          bMenuIn: false,
          bModalPermisos: false,
          bModImportar: false,
          itemNumMenu: '',
          itemNumMenuB: ''
        }
      },
      mounted() {
        this.nNivelActual = this.nNivel
        this.nSubNivel = this.nNivelActual+1
      },
      methods: {
        onMouseAction(oItem,sAccion) {
          sAccion
          oItem.bMostrar= true
        },
        onExpandMenu(tipo, val){
          if(tipo == 'A'){
            this.itemNumMenu == val ? this.itemNumMenu = '' : this.itemNumMenu = val
            this.itemNumMenuB = ''
          }else if(tipo == 'B'){
            this.itemNumMenuB == val ? this.itemNumMenuB = '' : this.itemNumMenuB = val
          }else{
            return false
          }
        },
        onIr(sRuta,sPermiso) {
          this.bMenuIn = false
          if(sRuta != '' && sPermiso=='1'){
            this.$router.push({ path: sRuta})
          }
          if(sPermiso=='0'){
            this.bModalPermisos = true
          }
        },
      },
  }
  </script>
  <style lang="scss" scoped>
  .hv{
      cursor: pointer;
  }
  .hv:hover{
      background: rgba($color: #0E69B0, $alpha: .2)
  }
  .icono-item-menu{
    width: 30px;
    height: 30px;
    font-size: 20px;
  }
  .cont-menu-principal{
    top: 105%;
    left: 0px;
    position: absolute;
    ul{
      list-style: none;
      padding: 0px;
      li{
        margin: 0px;
      }
    }
    ul{
      position: relative;
      width: 200px;
      border: solid white 0.4px;
      background: white;
      border-radius: 8px;
      box-shadow:  0px 0px 8px rgba($color: black, $alpha: .2);
    }
    ul >li{
      cursor:pointer;
      position: relative;
  
    }
    ul > li > ul{
      position: absolute;
      display: none;
      left: 100%;
      top: 0;
      width: 100%;
      z-index: 2;
    }
    ul > li:hover >ul{
      display: block;
    }
    .cont-item-menu{
      display:flex;
      padding: 8px 5px;
      transition: all 0.3s ease-in-out;
      line-height: 1em;
      font-size: 0.9em;
      align-items: center;
      border-radius: 8px;
      &:hover{
        background: #EDEDED;
      }
    }
    ul > li:hover > .icon-item-menu > .icon-chevron{
      transform: rotate(90deg);
    }
  }
  .cont-item-menu-xs{
    display: flex;
    padding: 8px 5px!important;
    transition: all 0.3s ease-in-out;
    line-height: 1em;
    font-size: 0.9em;
    align-items: center;
    border-radius: 8px;
    align-items: center;
    box-shadow: 0 0 5px rgba($color: black, $alpha: .2);
    &:hover{
      background: #EDEDED;
    }
  }
  .item-menu-xs{
    width: 100%;
    .icono-item-menu-xs{
      width: 40px;
      height: 40px;
      font-size: 20px;
    }
  }
  .dialog-menu{
    max-height: 55px!important;
  }
  
  
  </style>
  